/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2022 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../../core/IceEntity';

export class rptobject extends IceEntity {
  attributes: any = {};
  constructor(attr: any = {}) {
    super();
    for (let colName of Object.keys(attr)) {
      if (attr[colName] == null) continue;
      this.attributes[colName] = attr[colName];
    }
  }

  public gettablename(): string {
    return "RPTOBJECT";
  }
}
